__turbopack_context__.v({
  "container": "nWljnG_container",
});
